<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ 'base.add' | translate }} модель</h2>
    </v-card-title>
    <v-card-content>
      <v-text-field
        v-model="form.name"
        label="Назва моделі"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
      />
    </v-card-content>
    <v-card-actions>
      <v-btn :disabled="!form.name" @click="onCreate" :loading="loading">{{ 'base.add' | translate }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'AddModelModal',

  data () {
    return {
      form: {
        name: ''
      },
      errors: {
        name: null
      },
      loading: false
    }
  },
  mixins: [formErrorsMixin],
  methods: {
    async onCreate () {
      this.loading = true
      this.checkValidData()
      await new Promise(resolve => setTimeout(resolve, 300))
      if (this.errors.name === null) {
        const modelData = {
          name: this.form.name.trim()
        }

        this.$emit('create', modelData)
        this.$emit('close')
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
